export function isNull(value: any): boolean {
  return null === value;
}
